export const SET_PROFILE = "SET_PROFILE";

export default {
  SET_PROFILE,
};
